
import { CheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { BILLING_CYCLES } from "utils/constants";

import Button from "components/Button";

interface PackageCardProps {
  title: string;
  price?: string;
  features: string[];
  bestFit: string;
  isPriceFlexible?: boolean;
  className?: string;
  onSelect: () => void;
  period?: string;
}

export default function PackageCard({
  title,
  price,
  features,
  bestFit,
  isPriceFlexible = false,
  className = "",
  onSelect,
  period,
}: PackageCardProps) {
  const { t } = useTranslation();

  return (
    <div className={`w-full mx-auto border border-general-gray-300 rounded-lg ${className}`}>
      <div className="flex items-center justify-between p-5">
        <div>
          <h3 className="text-xl font-semibold">{title}</h3>
          <div>
            {!isPriceFlexible ? (
              <>
                <div className="font-semibold text-[15px]">
                  {price}KM /{" "}
                  {period === BILLING_CYCLES.YEARLY.toString() ? (
                    <span className="font-normal text-[15px]">
                      {t("checkout.yearly")}
                    </span>
                  ) : (
                    <span className="font-normal text-[15px]">
                      {t("checkout.monthly")}
                    </span>
                  )}
                </div>
              </>
            ) : (
              <div className="font-semibold">
                {t("checkout.priceNegotiable")}
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center">
          <Button type="button" className="w-full md:flex-1 h-12 px-4" onClick={isPriceFlexible ? onSelect : onSelect}>
            {isPriceFlexible
              ? t("checkout.packageCard.contactUs")
              : t("checkout.packageCard.selectPackage")}
          </Button>
        </div>
      </div>

      <div className="p-5">
        <ul className="space-y-3">
          <li className="flex items-start gap-2.5">
            <span className="flex-shrink-0">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border-2 border-general-green-700">
                <CheckIcon className="w-4 h-4 text-general-green-700 stroke-3" />
              </span>
            </span>
            <span className="text-sm text-foreground">{bestFit}</span>
          </li>
          {features.map((f, idx) => (
            <li key={idx} className="flex items-start gap-2.5">
              <span className="flex-shrink-0">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border-2 border-general-green-700">
                  <CheckIcon className="w-4 h-4 text-general-green-700 stroke-3" />
                </span>
              </span>
              <span className="text-sm text-foreground">{f}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
